import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  IpoLanguageService,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { RolloutProgressReportEntities } from '../../../../shared/self-inspection-reports/service/entities';
import { MultiWellPointProperties } from '../../../span-progress-entities';
import { buildRolloutReportUrl } from '../../../span-progress-view/popup-content/popup-pdf.utils';
import { wellColumns } from './well-table-columns';

@Component({
  selector: 'app-well-table',
  templateUrl: './well-table.component.html',
  styleUrl: './well-table.component.scss',
  standalone: false,
})
export class WellTableComponent {
  @Input() wellData: MultiWellPointProperties[];
  @Output() dismiss = new EventEmitter();

  columns = wellColumns;
  language$ = this.languageService.getLanguage$();

  constructor(
    private readonly languageService: IpoLanguageService,
    private readonly translate: IpoTranslatePipe,
    private readonly router: Router,
  ) {}

  closeModal() {
    this.dismiss.emit();
  }

  openWellReportPage(well: MultiWellPointProperties) {
    this.closeModal();
    window.open(
      buildRolloutReportUrl(
        this.router.url,
        RolloutProgressReportEntities.v3.MarkerTypes.MANHOLE,
        well.properties.id,
      ),
      '_blank',
    );
  }

  setStatusString(well: MultiWellPointProperties) {
    switch (well.status) {
      case 'DONE':
        return this.translate.transform('selfReportingPoints.status.done');
      case 'DONE_WITH_DEVIATION':
        return this.translate.transform(
          'selfReportingPoints.status.doneWithDeviation',
        );
      case 'IN_PROGRESS':
        return this.translate.transform('selfReportingPoints.status.started');
      default:
        return this.translate.transform('hpReportModal.pill.notDone');
    }
  }
}
